/**
 * Имя cookie согласия на использование куки — ставится модалкой ModalCookie
 * при нажатии «OK». Общий источник правды для компонентов, которым важен сам
 * факт согласия (например PromoBanner).
 */
export const CONSENT_COOKIE_NAME = 'consent_received';

/**
 * Событие window, которое ModalCookie шлёт в момент получения согласия, чтобы
 * другие компоненты могли отреагировать сразу, не дожидаясь перезагрузки.
 */
export const CONSENT_EVENT = 'cookie-consent-granted';
